export function getEditorUrl(isDeveloper: boolean): { url: string; origin: string } {
  const queryString = isDeveloper ? '?developer=true' : '';

  if (globalThis.location.hostname.includes('local.feathr.app')) {
    return {
      url: 'https://local.feathr.app:9008/' + queryString,
      origin: 'https://local.feathr.app:9008',
    };
  }

  if (BLACKBOX_URL.includes('blackbox.feathr.co')) {
    return {
      url: `https://forms.feathr.co/editor/index.html${queryString}`,
      origin: 'https://forms.feathr.co',
    };
  } else if (BLACKBOX_URL.includes('blackbox-staging.feathr.co')) {
    return {
      url: `https://forms-staging.feathr.co/editor/index.html${queryString}`,
      origin: 'https://forms-staging.feathr.co',
    };
  } else if (BLACKBOX_URL.includes('blackbox-qa.feathr.co')) {
    return {
      url: `https://forms-qa.feathr.co/editor/index.html${queryString}`,
      origin: 'https://forms-qa.feathr.co',
    };
  } else if (BLACKBOX_URL.includes('blackbox-dev.feathr.co')) {
    return {
      url: `https://forms-dev.feathr.co/editor/index.html${queryString}`,
      origin: 'https://forms-dev.feathr.co',
    };
  }

  return {
    url: 'https://local.feathr.app:9008/' + queryString,
    origin: 'https://local.feathr.app:9008',
  };
}
